"use strict";

function __export(m) {
  for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
__export(require("./admin/adminbenutzer"));
__export(require("./admin/adminbenutzercreate"));
__export(require("./admin/admingeschaeftsstelle"));
__export(require("./admin/adminkostenstelle"));
__export(require("./admin/adminoeffnungszeit"));
__export(require("./admin/adminoeffnungszeiten"));
__export(require("./admin/group"));
__export(require("./admin/groupright"));
__export(require("./admin/groupusergroup"));
__export(require("./admin/maklerdocadminfile"));
__export(require("./admin/maklerdocadminfilezuweisung"));
__export(require("./admin/partneradmin"));
__export(require("./admin/partneradminbetreuer"));
__export(require("./admin/partneradmincreate"));
__export(require("./admin/partneradminpartnershare"));
__export(require("./admin/partneradminupdate"));
__export(require("./admin/referat/referatadminreferat"));
__export(require("./admin/referat/referatadminteam"));
__export(require("./admin/referat/referatadminteamrule"));
__export(require("./admin/referat/referatadminteamruledata"));
__export(require("./admin/right"));
__export(require("./admin/zahlungsfreigabebenutzer"));
__export(require("./adresse/adresse"));
__export(require("./adresse/adressechangelog"));
__export(require("./adresse/adressecreate"));
__export(require("./adresse/adressestrassesearchresult"));
__export(require("./analyze/analyzeresult"));
__export(require("./archiv/archivdocument"));
__export(require("./archiv/archivdocumentdsgvo"));
__export(require("./archiv/archivdocumentgutachten"));
__export(require("./archiv/archivdocumentnotiz"));
__export(require("./archiv/person/archivdocumentperson"));
__export(require("./archiv/person/archivdocumentpersoncreate"));
__export(require("./archiv/person/archivdocumentpersonpolizze"));
__export(require("./archiv/person/archivdocumentpersonupdate"));
__export(require("./archiv/polizze/archivdocumentpolizze"));
__export(require("./archiv/polizze/archivdocumentpolizzecreate"));
__export(require("./archivadmin/archivdokumenteuebertragen"));
__export(require("./archivadmin/archivpostfach"));
__export(require("./archivadmin/archivteam"));
__export(require("./assistance/assistancebetreuer"));
__export(require("./assistance/assistancegruenekarte"));
__export(require("./assistance/assistanceperson"));
__export(require("./assistance/assistancepersonresult"));
__export(require("./assistance/assistancepolizze"));
__export(require("./assistance/assistancereferat"));
__export(require("./assistance/assistancetodocreate"));
__export(require("./betreuer/betreuer"));
__export(require("./betreuer/betreuerrabattkonto"));
__export(require("./betreuer/rabattkontobuchung"));
__export(require("./betreuerdatenadmin/betreuerprovisionsuebertrag"));
__export(require("./betreuerdatenadmin/betreuerstockuebertrag"));
__export(require("./betreuerdatenadmin/betreueruebertragparent"));
__export(require("./cms/cmsdata"));
__export(require("./cms/cmsdatatype"));
__export(require("./cms/cmsmedia"));
__export(require("./cms/cmsmediatype"));
__export(require("./datenschutz/datenschutzakt"));
__export(require("./elekkom/elekkomtokenresult"));
__export(require("./esign/esignlog"));
__export(require("./esign/esignpersonresult"));
__export(require("./esign/esignpersonupdate"));
__export(require("./esign/esignresendrequest"));
__export(require("./esign/esignresult"));
__export(require("./esign/esignstartrequest"));
__export(require("./esign/esignstatus"));
__export(require("./esign/esignupdaterequest"));
__export(require("./fahrzeug/fahrzeug"));
__export(require("./fahrzeug/fahrzeuglistenpreisabfrage"));
__export(require("./fahrzeug/fahrzeugresult"));
__export(require("./fastsearch/fastsearchkeyvaluepair"));
__export(require("./fastsearch/fastsearchresponse"));
__export(require("./fastsearch/person/fastsearchadresse"));
__export(require("./fastsearch/person/fastsearchkontakt"));
__export(require("./fastsearch/person/fastsearchkunde"));
__export(require("./fastsearch/person/fastsearchlocation"));
__export(require("./fastsearch/person/fastsearchperson"));
__export(require("./fastsearch/person/fastsearchtitel"));
__export(require("./fastsearch/polizze/fastsearchpolizze"));
__export(require("./fastsearch/schaden/fastsearchschaden"));
__export(require("./gebaeude/bewertungsgrundlage"));
__export(require("./gebaeude/gebaeude"));
__export(require("./gebaeude/gebaeudepolizzeninfo"));
__export(require("./gebaeude/gebaeuderesult"));
__export(require("./gehaltsumwandlung/gehaltsumwandlungbuchung"));
__export(require("./gehaltsumwandlung/gehaltsumwandlunggegenueberstellung"));
__export(require("./gehaltsumwandlung/gehaltsumwandlungzahlung"));
__export(require("./genehmigung/genehmigungkorrespondez"));
__export(require("./genehmigung/genehmigungpolizzeneinsicht"));
__export(require("./genehmigung/genehmigungpolizzensondertarif"));
__export(require("./genehmigung/genehmigungresult"));
__export(require("./genehmigung/genehmigungschadeneinsicht"));
__export(require("./haushalt/haushalt"));
__export(require("./haushalt/haushaltperson"));
__export(require("./haushalt/haushaltpolizze"));
__export(require("./haushalt/haushaltrisiko"));
__export(require("./hotline/hotlinebetreuer"));
__export(require("./hotline/hotlinekundenportal"));
__export(require("./hotline/hotlineperson"));
__export(require("./hotline/hotlinepersonresult"));
__export(require("./hotline/hotlinepolizze"));
__export(require("./hotline/hotlinereferat"));
__export(require("./hotline/hotlineschaden"));
__export(require("./hp/hpadresse"));
__export(require("./hp/hpbetreuer"));
__export(require("./hp/hpgebietsleiter"));
__export(require("./hp/hpgeschaeftsstelle"));
__export(require("./hp/hpgeschaeftsstellen"));
__export(require("./hp/hpgeschaeftsstelletypenum"));
__export(require("./hp/hpimage"));
__export(require("./hp/hpkontakt"));
__export(require("./hp/hpmitarbeiter"));
__export(require("./hp/hpoeffnungszeiten"));
__export(require("./hp/hpzahlungsart"));
__export(require("./hp/hpzeit"));
__export(require("./ie/ieausgang"));
__export(require("./ie/ieeingang"));
__export(require("./ie/ieezahltag"));
__export(require("./ie/iestatushistorie"));
__export(require("./ie/ungeklaertezahlungarchivresult"));
__export(require("./index/indexresult"));
__export(require("./index/indexsearch"));
__export(require("./index"));
__export(require("./info/dmwinfo"));
__export(require("./intranet/intranetuser"));
__export(require("./itservice/itserviceuser"));
__export(require("./keyvalue/keyvalue"));
__export(require("./keyvalue/keyvaluestring"));
__export(require("./klausel/klausel"));
__export(require("./klausel/merkmal"));
__export(require("./kontakt/kontakt"));
__export(require("./kundendatenadmin/kundendatenpersonbeziehung"));
__export(require("./kundendatenadmin/kundendatentrennen"));
__export(require("./kundendatenadmin/kundendatenzusammenfassen"));
__export(require("./makler/maklerfile"));
__export(require("./makler/maklerpolizzeprovision"));
__export(require("./makler/maklertarif"));
__export(require("./makler/maklertarifgruppe"));
__export(require("./makler/maklerteam"));
__export(require("./merkmal/merkmalcreate"));
__export(require("./merkmal/merkmalformat"));
__export(require("./motorsteuer/motorsteuer"));
__export(require("./motorsteuer/motorsteuerabfrage"));
__export(require("./obj/objekteinsicht"));
__export(require("./obj/objekteinsichtstatus"));
__export(require("./obj/version"));
__export(require("./omds/omdsarchivfile"));
__export(require("./omds/omdsfile"));
__export(require("./omds/omdsfileid"));
__export(require("./omds/omdspolizze"));
__export(require("./payload/message"));
__export(require("./payload/payload"));
__export(require("./payload/payloadadminbenutzer"));
__export(require("./payload/payloadadminbenutzercreate"));
__export(require("./payload/payloadadminbenutzerlist"));
__export(require("./payload/payloadadmingeschaeftsstelle"));
__export(require("./payload/payloadadmingeschaeftsstellelist"));
__export(require("./payload/payloadadminkostenstelle"));
__export(require("./payload/payloadadminkostenstellelist"));
__export(require("./payload/payloadadresse"));
__export(require("./payload/payloadadressechangedata"));
__export(require("./payload/payloadadressechangeloglist"));
__export(require("./payload/payloadadressechangepolizze"));
__export(require("./payload/payloadadressekorrdata"));
__export(require("./payload/payloadadresselist"));
__export(require("./payload/payloadadressestrassesearchresultlist"));
__export(require("./payload/payloadanalyzeresultlist"));
__export(require("./payload/payloadarchivdocumentdsgvolist"));
__export(require("./payload/payloadarchivdocumentgutachtenlist"));
__export(require("./payload/payloadarchivdocumentlist"));
__export(require("./payload/payloadarchivdocumentnotizlist"));
__export(require("./payload/payloadarchivdocumentpersoncreatelist"));
__export(require("./payload/payloadarchivdocumentpersonlist"));
__export(require("./payload/payloadarchivdocumentpersonpolizzelist"));
__export(require("./payload/payloadarchivdocumentpolizzecreatelist"));
__export(require("./payload/payloadarchivpostfachlist"));
__export(require("./payload/payloadarchivteamlist"));
__export(require("./payload/payloadassistanceperson"));
__export(require("./payload/payloadassistancepersonresultlist"));
__export(require("./payload/payloadassistancepolizze"));
__export(require("./payload/payloadbankverbindunglist"));
__export(require("./payload/payloadbenutzer"));
__export(require("./payload/payloadbenutzerlist"));
__export(require("./payload/payloadbenutzerstatus"));
__export(require("./payload/payloadbeteiligung"));
__export(require("./payload/payloadbetreuer"));
__export(require("./payload/payloadbetreuerprovisionsuebertrag"));
__export(require("./payload/payloadbetreuerprovisionsuebertraglist"));
__export(require("./payload/payloadbetreuerrabattkonto"));
__export(require("./payload/payloadbetreuerstockuebertrag"));
__export(require("./payload/payloadbetreuerstockuebertraglist"));
__export(require("./payload/payloadbetreuerzielbonilist"));
__export(require("./payload/payloadbetreuerzielprovlist"));
__export(require("./payload/payloadboolean"));
__export(require("./payload/payloadcmsdata"));
__export(require("./payload/payloadcmsdatalist"));
__export(require("./payload/payloadcmsmedia"));
__export(require("./payload/payloadcmsmedialist"));
__export(require("./payload/payloaddatenschutzakt"));
__export(require("./payload/payloaddatenschutzaktlist"));
__export(require("./payload/payloadeinzahlungresultlist"));
__export(require("./payload/payloadelekkomtokenresultlist"));
__export(require("./payload/payloadesignloglist"));
__export(require("./payload/payloadesignpersonresultlist"));
__export(require("./payload/payloadesignresultlist"));
__export(require("./payload/payloadfahrzeug"));
__export(require("./payload/payloadfahrzeugresultlist"));
__export(require("./payload/payloadfastsearchkundelist"));
__export(require("./payload/payloadfastsearchresponse"));
__export(require("./payload/payloadfastsearchresponselist"));
__export(require("./payload/payloadfilebucketmetadata"));
__export(require("./payload/payloadfilebucketmetadatalist"));
__export(require("./payload/payloadfinanzamtbestdata"));
__export(require("./payload/payloadfinanzamtbestpolizze"));
__export(require("./payload/payloadfremdefuehrung"));
__export(require("./payload/payloadgebaeude"));
__export(require("./payload/payloadgebaeuderesultlist"));
__export(require("./payload/payloadgehaltsumwandlunggegenueberstellung"));
__export(require("./payload/payloadgenehmigungkorrespondez"));
__export(require("./payload/payloadgenehmigungpolizzeneinsicht"));
__export(require("./payload/payloadgenehmigungpolizzensondertarif"));
__export(require("./payload/payloadgenehmigungresultlist"));
__export(require("./payload/payloadgenehmigungschadeneinsicht"));
__export(require("./payload/payloadgroup"));
__export(require("./payload/payloadgrouplist"));
__export(require("./payload/payloadgroupright"));
__export(require("./payload/payloadgrouprightlist"));
__export(require("./payload/payloadgroupusergroup"));
__export(require("./payload/payloadgroupusergrouplist"));
__export(require("./payload/payloadguthabendata"));
__export(require("./payload/payloadguthabenpolizze"));
__export(require("./payload/payloadhauptfaelligkeitdata"));
__export(require("./payload/payloadhauptfaelligkeitpolizze"));
__export(require("./payload/payloadhaushalt"));
__export(require("./payload/payloadhaushaltrisiko"));
__export(require("./payload/payloadhotlineperson"));
__export(require("./payload/payloadhotlinepersonresultlist"));
__export(require("./payload/payloadieausgang"));
__export(require("./payload/payloadieausganglist"));
__export(require("./payload/payloadieeingang"));
__export(require("./payload/payloadieeinganglist"));
__export(require("./payload/payloadieezahltag"));
__export(require("./payload/payloadindexresultlist"));
__export(require("./payload/payloadindexsearch"));
__export(require("./payload/payloadinformationlist"));
__export(require("./payload/payloadinteger"));
__export(require("./payload/payloadintranetuser"));
__export(require("./payload/payloadintranetuserlist"));
__export(require("./payload/payloadkaskoumstellungdata"));
__export(require("./payload/payloadkennzeichendata"));
__export(require("./payload/payloadkennzeichenpolizze"));
__export(require("./payload/payloadkeyvaluestringlist"));
__export(require("./payload/payloadklausellist"));
__export(require("./payload/payloadkontakt"));
__export(require("./payload/payloadkontaktlist"));
__export(require("./payload/payloadkundendatenpersonbeziehung"));
__export(require("./payload/payloadkundensegment"));
__export(require("./payload/payloadkundenverbund"));
__export(require("./payload/payloadlebendaten"));
__export(require("./payload/payloadlocaldatelist"));
__export(require("./payload/payloadlvkpolizzeleben"));
__export(require("./payload/payloadmahnhistorieresultlist"));
__export(require("./payload/payloadmahnstoppdata"));
__export(require("./payload/payloadmahnstopppolizze"));
__export(require("./payload/payloadmaklerdocadminfile"));
__export(require("./payload/payloadmaklerdocadminfilelist"));
__export(require("./payload/payloadmaklerdocadminfilezuweisunglist"));
__export(require("./payload/payloadmaklerfile"));
__export(require("./payload/payloadmaklerfilelist"));
__export(require("./payload/payloadmaklerpolizzeprovisionlist"));
__export(require("./payload/payloadmaklertarifgruppelist"));
__export(require("./payload/payloadmaklerteamlist"));
__export(require("./payload/payloadmerkmallist"));
__export(require("./payload/payloadmotorsteuer"));
__export(require("./payload/payloadnebenversicherunglist"));
__export(require("./payload/payloadobject"));
__export(require("./payload/payloadobjekteinsichtstatus"));
__export(require("./payload/payloadomdsfilelist"));
__export(require("./payload/payloadomdspolizzelist"));
__export(require("./payload/payloadopostenresultlist"));
__export(require("./payload/payloadpartner"));
__export(require("./payload/payloadpartneradmin"));
__export(require("./payload/payloadpartneradminbetreuerlist"));
__export(require("./payload/payloadpartneradmincreate"));
__export(require("./payload/payloadpartneradminlist"));
__export(require("./payload/payloadpartneradminpartnersharelist"));
__export(require("./payload/payloadpartnerlist"));
__export(require("./payload/payloadperson"));
__export(require("./payload/payloadpersonbestandsdaten"));
__export(require("./payload/payloadpersonbezugspersonresultlist"));
__export(require("./payload/payloadpersoncreate"));
__export(require("./payload/payloadpersonelektronischekommunikationloglist"));
__export(require("./payload/payloadpersongesundheitsfragebogenlist"));
__export(require("./payload/payloadpersongrosskunde"));
__export(require("./payload/payloadpersongrosskundebuchungresultlist"));
__export(require("./payload/payloadpersonkontaktlist"));
__export(require("./payload/payloadpersonkundenportallist"));
__export(require("./payload/payloadpersonloglist"));
__export(require("./payload/payloadpersonpoldruckoptions"));
__export(require("./payload/payloadpersonpolizzeresultlist"));
__export(require("./payload/payloadpersonpraemien"));
__export(require("./payload/payloadpersonreferatlist"));
__export(require("./payload/payloadpersonresultlist"));
__export(require("./payload/payloadpersonrisikokaptial"));
__export(require("./payload/payloadpersonrollelist"));
__export(require("./payload/payloadpersonschadenresultlist"));
__export(require("./payload/payloadpersonschadensatz"));
__export(require("./payload/payloadpersonschadensatzstatistiklist"));
__export(require("./payload/payloadpersonschelektronischekommunikationloglist"));
__export(require("./payload/payloadpoldruckoptions"));
__export(require("./payload/payloadpolizze"));
__export(require("./payload/payloadpolizzeaenderungen"));
__export(require("./payload/payloadpolizzeapollist"));
__export(require("./payload/payloadpolizzebuchungdetail"));
__export(require("./payload/payloadpolizzebuchungresultlist"));
__export(require("./payload/payloadpolizzecochecklist"));
__export(require("./payload/payloadpolizzedfzlist"));
__export(require("./payload/payloadpolizzedocumentspossibletypenlist"));
__export(require("./payload/payloadpolizzefampassxmldatenlist"));
__export(require("./payload/payloadpolizzefond"));
__export(require("./payload/payloadpolizzefreischadenlist"));
__export(require("./payload/payloadpolizzegenehmigung"));
__export(require("./payload/payloadpolizzegenehmigungkorrespondezlist"));
__export(require("./payload/payloadpolizzegenehmigunglist"));
__export(require("./payload/payloadpolizzeidentitaetsdatenlist"));
__export(require("./payload/payloadpolizzemahnstandresultlist"));
__export(require("./payload/payloadpolizzemailingfehlerlist"));
__export(require("./payload/payloadpolizzemailinglist"));
__export(require("./payload/payloadpolizzeobjekt"));
__export(require("./payload/payloadpolizzeoposten"));
__export(require("./payload/payloadpolizzeopostenarchivungeklaertezahlungen"));
__export(require("./payload/payloadpolizzeopostensummen"));
__export(require("./payload/payloadpolizzepersonresultlist"));
__export(require("./payload/payloadpolizzeproduktionsblatt"));
__export(require("./payload/payloadpolizzeprovisionlist"));
__export(require("./payload/payloadpolizzeprovisionresultlist"));
__export(require("./payload/payloadpolizzerabattkontoresult"));
__export(require("./payload/payloadpolizzerabattkontoresultlist"));
__export(require("./payload/payloadpolizzeresult"));
__export(require("./payload/payloadpolizzeresultlist"));
__export(require("./payload/payloadpolizzeschaden"));
__export(require("./payload/payloadpolizzezahlung"));
__export(require("./payload/payloadpolizzezahlungresultlist"));
__export(require("./payload/payloadpolizzezislist"));
__export(require("./payload/payloadpolizzezusaetzlichetexte"));
__export(require("./payload/payloadpolizzezusatzangabelist"));
__export(require("./payload/payloadposition"));
__export(require("./payload/payloadpositiongewinnkontolist"));
__export(require("./payload/payloadpositiongewinnprognoselist"));
__export(require("./payload/payloadpositionlebenbilanz"));
__export(require("./payload/payloadpositionlebenfond"));
__export(require("./payload/payloadpositionlebenfondanteilelist"));
__export(require("./payload/payloadpositionlebenkontolist"));
__export(require("./payload/payloadpositionprognoselist"));
__export(require("./payload/payloadpositionrentenkontolist"));
__export(require("./payload/payloadpositionresultlist"));
__export(require("./payload/payloadpositionselbstbehaltlist"));
__export(require("./payload/payloadpositionteilentnahmenlist"));
__export(require("./payload/payloadpositionveranlagunglist"));
__export(require("./payload/payloadpositionzuzahlunglist"));
__export(require("./payload/payloadquestionsdata"));
__export(require("./payload/payloadrabattkontobuchunglist"));
__export(require("./payload/payloadreferatadminteam"));
__export(require("./payload/payloadreferatadminteamlist"));
__export(require("./payload/payloadreferatadminteamruledata"));
__export(require("./payload/payloadreferatadminteamrulelist"));
__export(require("./payload/payloadright"));
__export(require("./payload/payloadrightlist"));
__export(require("./payload/payloadrisikoanalyse"));
__export(require("./payload/payloadrisikoklassifizierunglist"));
__export(require("./payload/payloadrkwauskunftresult"));
__export(require("./payload/payloadrohbauverlaengerungdata"));
__export(require("./payload/payloadrohbauverlaengerungpolizze"));
__export(require("./payload/payloadrueckversicherung"));
__export(require("./payload/payloadschaden"));
__export(require("./payload/payloadschadenbeteiligung"));
__export(require("./payload/payloadschadenbeteiligungresultlist"));
__export(require("./payload/payloadschadenbuchungdetail"));
__export(require("./payload/payloadschadenchecklistcontainer"));
__export(require("./payload/payloadschadenelektronischekommunikationloglist"));
__export(require("./payload/payloadschadenfeedbacklist"));
__export(require("./payload/payloadschadenresultlist"));
__export(require("./payload/payloadschadenzahlungdetail"));
__export(require("./payload/payloadsoftphonecall"));
__export(require("./payload/payloadsoftphonecallinfo"));
__export(require("./payload/payloadsoftphonekontakt"));
__export(require("./payload/payloadsoftphonekontaktlist"));
__export(require("./payload/payloadsoftphonelink"));
__export(require("./payload/payloadsoftphonelinklist"));
__export(require("./payload/payloadspartenentfalldata"));
__export(require("./payload/payloadspartenentfallpolizze"));
__export(require("./payload/payloadsperrscheindata"));
__export(require("./payload/payloadsperrscheinpolizze"));
__export(require("./payload/payloadstornodata"));
__export(require("./payload/payloadstornopolizze"));
__export(require("./payload/payloadstring"));
__export(require("./payload/payloadstringlist"));
__export(require("./payload/payloadsvsterbetabresultlist"));
__export(require("./payload/payloadterminlist"));
__export(require("./payload/payloadtextbaustein"));
__export(require("./payload/payloadtextbausteinresultlist"));
__export(require("./payload/payloadtodo"));
__export(require("./payload/payloadtodokommentar"));
__export(require("./payload/payloadtodokommentarlist"));
__export(require("./payload/payloadtodoresult"));
__export(require("./payload/payloadtodoresultlist"));
__export(require("./payload/payloadungeklaertezahlungarchivresultlist"));
__export(require("./payload/payloadusersetting"));
__export(require("./payload/payloadverbundrisiko"));
__export(require("./payload/payloadvertrag"));
__export(require("./payload/payloadvertraganpassung"));
__export(require("./payload/payloadvertragresultlist"));
__export(require("./payload/payloadvertragselbstbehaltlist"));
__export(require("./payload/payloadvertreter"));
__export(require("./payload/payloadvertreterbuchunglist"));
__export(require("./payload/payloadvertreterzusatzdaten"));
__export(require("./payload/payloadvinkulierunglist"));
__export(require("./payload/payloadvsb"));
__export(require("./payload/payloadvsbresultlist"));
__export(require("./payload/payloadwartungsdiensteresultlist"));
__export(require("./payload/payloadwkzabmeldungdata"));
__export(require("./payload/payloadwkzabmeldungpolizze"));
__export(require("./payload/payloadwtallgemeindata"));
__export(require("./payload/payloadwtallgemeinpolizze"));
__export(require("./payload/payloadzahlungsfreigabebenutzer"));
__export(require("./payload/payloadzahlungsfreigabebenutzerlist"));
__export(require("./payload/payloadzahlungsvereinbarungdata"));
__export(require("./payload/payloadzahlungsvereinbarungpolizze"));
__export(require("./payload/payloadzahlweisechangedata"));
__export(require("./payload/payloadzahlweisechangepolizze"));
__export(require("./payload/payloadzahlweisesave"));
__export(require("./payload/payloadzinsspektrum"));
__export(require("./payload/payloadzulassungarchivlist"));
__export(require("./payload/payloadzulassungresult"));
__export(require("./payload/payloadzulassungresultlist"));
__export(require("./payload/payloadzusaetzlichetexte"));
__export(require("./person/bankverbindung"));
__export(require("./person/benutzer"));
__export(require("./person/benutzerbetreuer"));
__export(require("./person/benutzerflags"));
__export(require("./person/benutzerstatus"));
__export(require("./person/betreuer/betreuerzielboni"));
__export(require("./person/betreuer/betreuerzielprov"));
__export(require("./person/bezugsberechtigter"));
__export(require("./person/druck/personpoldruckoptions"));
__export(require("./person/druck/personpoldrucksenddata"));
__export(require("./person/grosskunde/persongrosskunde"));
__export(require("./person/grosskunde/persongrosskundebuchungresult"));
__export(require("./person/kundenportal/kundenportallogin"));
__export(require("./person/kundenportal/personkundenportal"));
__export(require("./person/kundensegment/kundensegment"));
__export(require("./person/kundensegment/kundenverbund"));
__export(require("./person/kundensegment/verbundperson"));
__export(require("./person/kundensegment/verbundpolizze"));
__export(require("./person/kundensegment/verbundrisiko"));
__export(require("./person/lebendaten/ausweis"));
__export(require("./person/lebendaten/exponent"));
__export(require("./person/lebendaten/lebendaten"));
__export(require("./person/lebendaten/lebendatenwe"));
__export(require("./person/lebendaten/risikoklassifizierung"));
__export(require("./person/lebendaten/steuerdaten"));
__export(require("./person/mandat"));
__export(require("./person/partner"));
__export(require("./person/partnerbetreuer"));
__export(require("./person/person"));
__export(require("./person/personbestandsdaten"));
__export(require("./person/personbezugspersonresult"));
__export(require("./person/personbuchung"));
__export(require("./person/personcreate"));
__export(require("./person/personcreatemodel"));
__export(require("./person/personelektronischekommunikationlog"));
__export(require("./person/persongesundheitsfragebogen"));
__export(require("./person/personkontakt"));
__export(require("./person/personlog"));
__export(require("./person/personpolizzeresult"));
__export(require("./person/personpraemien"));
__export(require("./person/personreferat"));
__export(require("./person/personresult"));
__export(require("./person/personrisikokaptial"));
__export(require("./person/personrisikokaptialposition"));
__export(require("./person/personrolle"));
__export(require("./person/personschadenresult"));
__export(require("./person/personschadensatz"));
__export(require("./person/personschadensatzstatistik"));
__export(require("./person/personschelektronischekommunikationlog"));
__export(require("./person/persontabs"));
__export(require("./person/rechtsform/rechtsformkeyvalue"));
__export(require("./person/risikoanalyse/abdeckung"));
__export(require("./person/risikoanalyse/risiko"));
__export(require("./person/risikoanalyse/risikoanalyse"));
__export(require("./polizze/druck/gruenekartedruck"));
__export(require("./polizze/druck/poldruckoptions"));
__export(require("./polizze/druck/poldruckquestions"));
__export(require("./polizze/druck/poldrucksenddata"));
__export(require("./polizze/druck/question/question"));
__export(require("./polizze/druck/question/questiongroup"));
__export(require("./polizze/druck/question/questionsdata"));
__export(require("./polizze/fremdefuehrung/fremdefuehrung"));
__export(require("./polizze/fremdefuehrung/fremdefuehrungeintrag"));
__export(require("./polizze/leben/lvkerlebensleistungpanel"));
__export(require("./polizze/leben/lvkpensionsvereinbarungpanel"));
__export(require("./polizze/leben/lvkpolizzeleben"));
__export(require("./polizze/leben/lvkrisikopanel"));
__export(require("./polizze/leben/lvktarifdatenpanel"));
__export(require("./polizze/leben/lvkverspersonpanel"));
__export(require("./polizze/leben/lvkvertrag"));
__export(require("./polizze/leben/lvkzusatzversicherungpanel"));
__export(require("./polizze/leben/lvkzusvers"));
__export(require("./polizze/leben/lvkzwischenauszahlungpanel"));
__export(require("./polizze/leben/polizzecocheck"));
__export(require("./polizze/leben/polizzefond"));
__export(require("./polizze/leben/polizzeidentitaetsdaten"));
__export(require("./polizze/leben/polizzeproduktionsblatt"));
__export(require("./polizze/leben/polizzeproduktionsblatteintrag"));
__export(require("./polizze/leben/polizzezis"));
__export(require("./polizze/leben/polizzezistreffer"));
__export(require("./polizze/leben/rkwauskunftresult"));
__export(require("./polizze/leben/rkwrentenpanel"));
__export(require("./polizze/leben/valueproperties"));
__export(require("./polizze/leben/yearmonthmodel"));
__export(require("./polizze/leben/zinsspektrum"));
__export(require("./polizze/polizze"));
__export(require("./polizze/polizzeaenderung"));
__export(require("./polizze/polizzeaenderungen"));
__export(require("./polizze/polizzeapol"));
__export(require("./polizze/polizzeapolentry"));
__export(require("./polizze/polizzebuchungdetail"));
__export(require("./polizze/polizzebuchungresult"));
__export(require("./polizze/polizzedfz"));
__export(require("./polizze/polizzedocumentspossibletypen"));
__export(require("./polizze/polizzefampassxmldaten"));
__export(require("./polizze/polizzefreischaden"));
__export(require("./polizze/polizzegenehmigung"));
__export(require("./polizze/polizzegenehmigungkorrespondez"));
__export(require("./polizze/polizzemahnstandresult"));
__export(require("./polizze/polizzemailing"));
__export(require("./polizze/polizzemailingfehler"));
__export(require("./polizze/polizzeobjekt"));
__export(require("./polizze/polizzeoposten"));
__export(require("./polizze/polizzeopostenarchivungeklaertezahlungen"));
__export(require("./polizze/polizzeopostenprov"));
__export(require("./polizze/polizzeopostenresult"));
__export(require("./polizze/polizzeopostensummen"));
__export(require("./polizze/polizzepersonresult"));
__export(require("./polizze/polizzepraemie"));
__export(require("./polizze/polizzeprovision"));
__export(require("./polizze/polizzeprovisionresult"));
__export(require("./polizze/polizzerabattkontoresult"));
__export(require("./polizze/polizzeresult"));
__export(require("./polizze/polizzeschaden"));
__export(require("./polizze/polizzetabs"));
__export(require("./polizze/polizzezahlung"));
__export(require("./polizze/polizzezahlungresult"));
__export(require("./polizze/polizzezusaetzlichetexte"));
__export(require("./polizze/polizzezusatzangabe"));
__export(require("./polizze/vertrag/anpassung/vertraganpassung"));
__export(require("./polizze/vertrag/beteiligung/beteiligung"));
__export(require("./polizze/vertrag/beteiligung/beteiligungfremdanstalten"));
__export(require("./polizze/vertrag/nebenversicherung/nebenversicherung"));
__export(require("./polizze/vertrag/position/leben/positiongewinnkonto"));
__export(require("./polizze/vertrag/position/leben/positiongewinnprognose"));
__export(require("./polizze/vertrag/position/leben/positionlebenbilanz"));
__export(require("./polizze/vertrag/position/leben/positionlebendepotauszug"));
__export(require("./polizze/vertrag/position/leben/positionlebenfondanteile"));
__export(require("./polizze/vertrag/position/leben/positionlebenkonto"));
__export(require("./polizze/vertrag/position/leben/positionlebenprovision"));
__export(require("./polizze/vertrag/position/leben/positionprognose"));
__export(require("./polizze/vertrag/position/leben/positionrentenkonto"));
__export(require("./polizze/vertrag/position/leben/positionteilentnahmen"));
__export(require("./polizze/vertrag/position/leben/positionveranlagung"));
__export(require("./polizze/vertrag/position/leben/positionvorpositionsdaten"));
__export(require("./polizze/vertrag/position/leben/positionzuzahlung"));
__export(require("./polizze/vertrag/position/leben/postionlebenfondauswahl"));
__export(require("./polizze/vertrag/position/position"));
__export(require("./polizze/vertrag/position/positionlebenfond"));
__export(require("./polizze/vertrag/position/positionresult"));
__export(require("./polizze/vertrag/position/positionselbstbehalt"));
__export(require("./polizze/vertrag/position/positionsrabattorzuschlag"));
__export(require("./polizze/vertrag/position/positionzusaetzlichetexte"));
__export(require("./polizze/vertrag/rueckversicherung/rueckversfakuexzedent"));
__export(require("./polizze/vertrag/rueckversicherung/rueckversicherung"));
__export(require("./polizze/vertrag/rueckversicherung/rueckverskumul"));
__export(require("./polizze/vertrag/rueckversicherung/rueckverskumulvertrag"));
__export(require("./polizze/vertrag/rueckversicherung/rueckversoblexzedent"));
__export(require("./polizze/vertrag/vertrag"));
__export(require("./polizze/vertrag/vertragbuchung"));
__export(require("./polizze/vertrag/vertragfremdefuehrung"));
__export(require("./polizze/vertrag/vertragpml"));
__export(require("./polizze/vertrag/vertragresult"));
__export(require("./polizze/vertrag/vertragselbstbehalt"));
__export(require("./polizze/vertrag/vertragsrabattorzuschlag"));
__export(require("./polizze/vertrag/vertragsteuer"));
__export(require("./polizze/vertrag/vertragzusaetzlichetexte"));
__export(require("./polizze/vertrag/vinkulierung/vinkulierung"));
__export(require("./polizze/vertrag/vinkulierung/vinkulierungkredite"));
__export(require("./polizze/zusaetzlichetexte"));
__export(require("./rights/rightsconst"));
__export(require("./schaden/beteil/schadenbeteiligung"));
__export(require("./schaden/beteil/schadenbeteiligungresult"));
__export(require("./schaden/beteiligungsbuchung"));
__export(require("./schaden/feedback/schadenfeedback"));
__export(require("./schaden/feedback/schadenfeedbackantwort"));
__export(require("./schaden/rueckversicherungsbuchung"));
__export(require("./schaden/schaden"));
__export(require("./schaden/schadenbestandszahlen"));
__export(require("./schaden/schadenbeteiligter"));
__export(require("./schaden/schadenbuchung"));
__export(require("./schaden/schadenbuchungdetail"));
__export(require("./schaden/schadenchecklist"));
__export(require("./schaden/schadenchecklistcontainer"));
__export(require("./schaden/schadendeckungsbedenken"));
__export(require("./schaden/schadenelektronischekommunikationlog"));
__export(require("./schaden/schadenjahrsparte"));
__export(require("./schaden/schadenkosten"));
__export(require("./schaden/schadenlebenbestandszahlen"));
__export(require("./schaden/schadenlebenflvbestandszahlen"));
__export(require("./schaden/schadenlebenpzvbestandszahlen"));
__export(require("./schaden/schadenreferent"));
__export(require("./schaden/schadenresult"));
__export(require("./schaden/schadentabs"));
__export(require("./schaden/schadenzahlung"));
__export(require("./schaden/schadenzahlungdetail"));
__export(require("./schaden/schadenzahlungempfaenger"));
__export(require("./schaden/schadenzahlungposition"));
__export(require("./schaden/scheck"));
__export(require("./softphone/softphonecall"));
__export(require("./softphone/softphonecallinfo"));
__export(require("./softphone/softphonecallinfoupdate"));
__export(require("./softphone/softphonekontakt"));
__export(require("./softphone/softphonelink"));
__export(require("./storage/storagefile"));
__export(require("./svsterbetab/svsterbetabresult"));
__export(require("./termin/termin"));
__export(require("./text/textbaustein"));
__export(require("./text/textbausteinresult"));
__export(require("./todo/information"));
__export(require("./todo/todo"));
__export(require("./todo/todocreation"));
__export(require("./todo/tododokument"));
__export(require("./todo/todoerledigung"));
__export(require("./todo/todokommentar"));
__export(require("./todo/todoresult"));
__export(require("./todo/todowiedervorlage"));
__export(require("./token/emailtokenrequest"));
__export(require("./token/loginemailtokenrequest"));
__export(require("./token/mobilnrtokenrequest"));
__export(require("./user/geburtstagsetting"));
__export(require("./user/navigationsetting"));
__export(require("./user/usersetting"));
__export(require("./user/usersettingsenvelope"));
__export(require("./versbest/versbestfahrzeug"));
__export(require("./versbest/versbestrequest"));
__export(require("./vertreter/vertreter"));
__export(require("./vertreter/vertreterbuchung"));
__export(require("./vertreter/vertreterzusatzdaten"));
__export(require("./vsb/vsb"));
__export(require("./vsb/vsbresult"));
__export(require("./wartungsdienste/adresse/adressechange"));
__export(require("./wartungsdienste/adresse/adressechangedata"));
__export(require("./wartungsdienste/adresse/adressechangepolizze"));
__export(require("./wartungsdienste/adressekorr/adressekorrdata"));
__export(require("./wartungsdienste/adressekorr/adressekorrperson"));
__export(require("./wartungsdienste/adressekorr/adressekorrpersonrolle"));
__export(require("./wartungsdienste/adressekorr/adressekorrpolizze"));
__export(require("./wartungsdienste/allgemein/wtallgemeindata"));
__export(require("./wartungsdienste/allgemein/wtallgemeinpolizze"));
__export(require("./wartungsdienste/change"));
__export(require("./wartungsdienste/changedata"));
__export(require("./wartungsdienste/changedatapolizze"));
__export(require("./wartungsdienste/changepolizze"));
__export(require("./wartungsdienste/changepolizzeesign"));
__export(require("./wartungsdienste/file/filebucketmetadata"));
__export(require("./wartungsdienste/file/fileupload"));
__export(require("./wartungsdienste/file/fileuploadcustom"));
__export(require("./wartungsdienste/finanzamtbest/finanzamtbestdata"));
__export(require("./wartungsdienste/finanzamtbest/finanzamtbestpolizze"));
__export(require("./wartungsdienste/guthaben/faelligkeit"));
__export(require("./wartungsdienste/guthaben/guthabendata"));
__export(require("./wartungsdienste/guthaben/guthabenpolizze"));
__export(require("./wartungsdienste/hauptfaelligkeit/hauptfaelligkeitdata"));
__export(require("./wartungsdienste/hauptfaelligkeit/hauptfaelligkeitpolizze"));
__export(require("./wartungsdienste/kaskoumstellung/kaskoumstellungdata"));
__export(require("./wartungsdienste/kaskoumstellung/kaskoumstellungpolizze"));
__export(require("./wartungsdienste/kaskoumstellung/kaskoumstellungvertrag"));
__export(require("./wartungsdienste/kaskoumstellung/kaskoumstellungvertragoptions"));
__export(require("./wartungsdienste/kfz/kennzeichen/kennzeichendata"));
__export(require("./wartungsdienste/kfz/kennzeichen/kennzeichenpolizze"));
__export(require("./wartungsdienste/kfz/storno/stornodata"));
__export(require("./wartungsdienste/kfz/storno/stornogrund"));
__export(require("./wartungsdienste/kfz/storno/stornoguthaben"));
__export(require("./wartungsdienste/kfz/storno/stornokfz"));
__export(require("./wartungsdienste/kfz/storno/stornokfzdata"));
__export(require("./wartungsdienste/kfz/storno/stornopolizze"));
__export(require("./wartungsdienste/kfz/wkz/wkzabmeldungdata"));
__export(require("./wartungsdienste/kfz/wkz/wkzabmeldungkfz"));
__export(require("./wartungsdienste/kfz/wkz/wkzabmeldungpolizze"));
__export(require("./wartungsdienste/list/wartungsdiensteresult"));
__export(require("./wartungsdienste/mahnstopp/mahnstoppdata"));
__export(require("./wartungsdienste/mahnstopp/mahnstopppolizze"));
__export(require("./wartungsdienste/rohbauverlaengerung/rohbauverlaengerungdata"));
__export(require("./wartungsdienste/rohbauverlaengerung/rohbauverlaengerungpolizze"));
__export(require("./wartungsdienste/sepamandat/sepamandatupload"));
__export(require("./wartungsdienste/spartenentfall/spartenentfalldata"));
__export(require("./wartungsdienste/spartenentfall/spartenentfallpolizze"));
__export(require("./wartungsdienste/spartenentfall/spartenentfallvertrag"));
__export(require("./wartungsdienste/sperrschein/sperrscheindata"));
__export(require("./wartungsdienste/sperrschein/sperrscheinpolizze"));
__export(require("./wartungsdienste/zahlungsvereinbarung/zahlungsvereinbarungdata"));
__export(require("./wartungsdienste/zahlungsvereinbarung/zahlungsvereinbarungpolizze"));
__export(require("./wartungsdienste/zahlweise/zahlweisechangedata"));
__export(require("./wartungsdienste/zahlweise/zahlweisechangepolizze"));
__export(require("./wartungsdienste/zahlweise/zahlweiseesignstatus"));
__export(require("./wartungsdienste/zahlweise/zahlweisesave"));
__export(require("./zahlungen/einzahlungresult"));
__export(require("./zahlungen/mahnhistorieresult"));
__export(require("./zahlungen/opostenresult"));
__export(require("./zulassung/zulassungarchiv"));
__export(require("./zulassung/zulassungfahrzeughalterresult"));
__export(require("./zulassung/zulassungkfzresult"));
__export(require("./zulassung/zulassungresult"));